// E-Ticaret › Hakkımızda Ayarları kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'ecommerce.about';

export const ecommerceAboutGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'Hakkımızda sayfası nasıl hazırlanır?'),
  intro: t(`${G}.intro`, 'Sitenizin Hakkımızda sayfasını bölüm bölüm burada hazırlarsınız. Sayfa Ana Başlık, Hikayemiz, Değerlerimiz, Neden Bizi Seçmelisiniz ve CTA bölümlerinden oluşur; isterseniz sayfaya yan menüde görünen ek sekmeler de eklersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Hakkımızda Sayfası Ayarları'),
    tabs: t(`${G}.regions.tabs`, 'Sekmeler ve +'),
    body: t(`${G}.regions.body`, 'Bölümler'),
    footer: t(`${G}.regions.footer`, 'Varsayılan ayarlara sıfırla'),
  },
  navItems: [
    t(`${G}.nav.general`, 'Hakkımızda Ayarları'),
    t(`${G}.nav.custom`, 'Özel sekmeler'),
  ],
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Ana başlık ve hikaye metni'),
      text: t(`${G}.s1.text`, '"Ana Başlık Bölümü" sayfanın en üstündeki büyük başlık / görsel alanıdır. "Hikayemiz Bölümü"nde başlık, açıklama (hikaye metni) ve arka plan rengini yazın. Her bölümün başındaki görünürlük anahtarıyla o bölümü sayfada gösterir veya gizlersiniz.'),
      tips: [
        t(`${G}.s1.tip1`, 'Değişiklikler siz yazdıkça bir an sonra kendiliğinden kaydedilir; ayrı bir Kaydet düğmesi yoktur.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Görsel ve istatistik paneli'),
      text: t(`${G}.s2.text`, '"Hikaye metninin yanında görsel göster" açıksa hikaye metninin yanında bir görsel görünür; görseli yükleyin ya da "Görsel adresi"ne yapıştırın. "İstatistik Paneli Görünürlüğü" hikaye bölümündeki sayı kutucuklarını açar; her kutucuğa Başlık ve Değer yazın, panelin arka plan ve yazı rengini seçin.'),
      tips: [
        t(`${G}.s2.tip1`, '"Veri kutucuklarında kenarlık göster" kutucukların çevresine çizgi ekler.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Değerler, Neden Biz ve CTA'),
      text: t(`${G}.s3.text`, '"Değerlerimiz Bölümü"nde önce "Bölüm şablonu"nu seçin, sonra her değer için başlık, ikon, açıklama ve renk girin. "Neden Bizi Seçmelisiniz Bölümü"nde başlık, açıklama, arka plan rengi ve özellik maddelerini yazın. "CTA / İş Birliği Bölümü" sayfanın sonundaki çağrı / iş birliği alanıdır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Renk ve stil ayarları'),
      text: t(`${G}.s4.text`, 'Her bölümde "Arka Plan Rengi" ve gerekiyorsa başlık rengi, başlık boyutu (px), alt başlık / üst etiket rengi gibi stil alanları bulunur. Değerlerimiz bölümünde metin sütunları şablonu seçiliyken "Önizleme" sonucu hemen gösterir.'),
    },
    {
      region: 'tabs',
      title: t(`${G}.s5.title`, '5. Ek sekmeler'),
      text: t(`${G}.s5.text`, 'Sekmelerin sağındaki + (Yeni Sekme Ekle) Hakkımızda sayfasına yan menüde görünen yeni bir sekme ekler (ör. Misyon, Vizyon). Sekmede "Sekme Adı" (yan menüde görünür), "Sayfa Başlığı", arka plan rengi, ana içerik (HTML editör) ve "Yeni Bölüm Ekle" ile başlık-içerik-görsel bölümleri girilir. "Durum" düğmesiyle sekmeyi Aktif ya da Gizli yaparsınız.'),
      tips: [
        t(`${G}.s5.tip1`, 'Sekmeleri sürükleyerek sıralayın; bölümleri sürükleyerek veya oklarla sıralayın. Aynı sıra sitede de görünür.'),
        t(`${G}.s5.tip2`, 'Sekmedeki değişiklikler hemen kaydedilir. Çöp kutusu simgesi sekmeyi onay sorduktan sonra kalıcı olarak siler; bu işlem geri alınamaz.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Varsayılana dönmek'),
      text: t(`${G}.s6.text`, 'Başlığın sağındaki "Varsayılan ayarlara sıfırla" düğmesi ana Hakkımızda bölümlerindeki tüm metin ve ayarları hazır varsayılanlara döndürür ve bu hâl kendiliğinden kaydedilir. Onay sorulmaz; yalnız gerçekten baştan başlamak istediğinizde kullanın.'),
      tips: [
        t(`${G}.s6.tip1`, 'Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
      ],
    },
  ],
});
